module.exports = __webpack_public_path__ + "static/media/holiday2.0ae85798.webp";